import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const HolidayService = {
    list: async () => axios.get(`${API_KEEPER}/holiday/list`).then(({data}) => data).catch((err) => { throw err }),
    save: async (data) => axios.post(`${API_KEEPER}/holiday`, data).then((data) => data).catch((err) => { throw err }),
    update: async (data) => axios.put(`${API_KEEPER}/holiday`, data).then((data) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_KEEPER}/holiday/${id}`).then((data) => data).catch((err) => { throw err }),
    delete: async (id) => axios.delete(`${API_KEEPER}/holiday/${id}`).then((data) => data).catch((err) => { throw err }),
    }

export default HolidayService;